import request from '../request'
 
//我的错题-查询
export function getList(params) {
  return request({
    url: `/errquestion/list`,
    method: 'get',
    params
  })
}